import { createSlice } from "@reduxjs/toolkit";
import { securityApi } from "apis/eduidSecurity";
// export this for use in tests
export const initialState = {
    credentials: [],
};
const securitySlice = createSlice({
    name: "security",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(securityApi.endpoints.requestCredentials.matchFulfilled, (state, action) => {
            state.credentials = action.payload.payload.credentials;
        })
            .addMatcher(securityApi.endpoints.removeWebauthnToken.matchFulfilled, (state, action) => {
            state.credentials = action.payload.payload.credentials;
        })
            .addMatcher(securityApi.endpoints.postDeleteAccount.matchFulfilled, (state, action) => {
            state.location = action.payload.payload.location;
        })
            .addMatcher(securityApi.endpoints.registerWebauthn.matchFulfilled, (state, action) => {
            state.credentials = action.payload.payload.credentials;
        });
    },
});
export default securitySlice;
